<template>


  <div class="grid">
    <loading :active="isLoadingModel" :can-cancel="true" color="#274461" :is-full-page="fullPage"></loading>
    <div class="col-12">
      <div class="card">
        <!-- {{ breadcrumbItems }} -->
        <Breadcrumb :home="breadcrumbHome" :model="breadcrumbItems">
                <template #item="{ item, props }">
                     <router-link v-if="item.to" v-slot="{ href, navigate }"  :to="item.to" custom>
                        <a :href="href"   @click="navigate" >
                            <span :class="[item.icon, 'text-color']" ></span>
                            <span class="text-primary font-semibold">{{ item.label }}</span>
                        </a>
                    </router-link> 
                    <a v-else :href="item.url" :target="item.target" v-bind="props.action">
                    <span class="text-color">{{ item.label }}</span>
                </a>
                </template>
            </Breadcrumb>
        <Toast />
        <div class="p-fluid formgrid grid" style="margin-top: 2%">

          <!-- <div class="field col-12 md:col-2">
            <span class="p-float-label">
              <InputText format="text" v-model="owner_driver_name"> </InputText>
              <label>Owner/Driver name</label>
            </span>
          </div> -->

          <div class="field col-12 md:col-2">
            <span class="p-float-label">
              <InputText format="number" v-model="reg_number"> </InputText>
              <label>Registration Number</label>
            </span>
          </div>

          <div class="field col-12 md:col-2">
            <!-- <span class="p-float-label">
              <InputText type="text" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="10"
                format="number" v-model="mob_number">
              </InputText>
              <label>Mobile Number</label>
            </span> -->
            <span class="p-float-label">
              <Calendar inputId="fitness_validity" v-model="filter_createIdDate"  dateFormat="dd-mm-yy"/>
              <label for="date">From Date</label>
            </span>
          </div>

      

          <div class="field col-12 md:col-2">
            <span class="p-float-label">
              <Calendar inputId="fitness_validity" v-model="filter_createIdDateTO"  dateFormat="dd-mm-yy"/>
              <label for="date">To Date</label>
            </span>
            
          </div>
          <div class="field col-12 md:col-2">
            <span class="p-float-label">
              <Dropdown id="User" filter v-model="vehicle_dropdownItem" :options="vehicle_dropdownItems"
                optionLabel="name">
              </Dropdown>
              <label for="vehicle_type">Vehicle Type</label>
            </span>
          </div>
          <div class="field col-12 md:col-2">
            <span class="p-float-label">
              <Dropdown v-if="user_key && (user_key == 'Admin' || user_key == 'admin')" id="state" filter
                v-model="client_id_search" :options="client_id_dropdown" optionLabel="name" :optionValue="code"
                @change="get_vehicle_type_master"></Dropdown>
              <label>Select Client</label>
            </span>
          </div>
          
          
        </div>

        <div class="p-fluid formgrid grid">
          <div class="field col-12 md:col-2" v-if="showFilter">
            <span class="p-float-label">
              <Dropdown id="User" v-model="beacon_option" :options="beacon_dropdown" optionLabel="name">
              </Dropdown>
              <label for="vehicle_type">Beacon</label>
            </span>
          </div>
          <div class="field col-12 md:col-2" v-if="!showFilter">
            <Button style="background-color: #349CE4; border: 1px solid #349CE4;" icon="pi pi-search"
              v-tooltip.bottom="'Search'" @click="search(1)" />

            <button v-if="!showFirstFilter"
              style=" background-color: #3498db;  color: white; border: none; border-radius: 5px; margin-left: 10px; padding: 10px 20px; font-size: 16px; cursor: pointer; transition: background-color 0.3s; box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);"
              @click="show_filter()">
               more 
            </button>
           
          </div>
          <div class="field col-12 md:col-2" v-if="showFilter">
            <Button style="background-color: #349CE4; border: 1px solid #349CE4;" icon="pi pi-search"
              v-tooltip.bottom="'Search'" @click="search(1)" />
            <!-- <button
              v-if="!showFilter"
              style="color: blue; border: none; background: none;"
              @click="show_filter()"
              >more....
            </button>   -->
          </div>
          <div class="field col-12 md:col-2" >
            
          </div>
        </div>
        <!-- <Toolbar class="mb-1">
          <template v-slot:start>
            <div class="p-fluid formgrid grid">
            <div class="field col-2 md:col-2">
                <span class="p-float-label">
                <InputText  format="text"  v-model="owner_driver_name"  > </InputText>
                <label>Owner/Driver name</label>
              </span>
              </div>
              <div class="field col-2 md:col-2">
                <span class="p-float-label">
                <InputText  format="number"  v-model="reg_number"  > </InputText>
                <label>Registration Number</label>
              </span>
              </div>
              <div class="field col-2 md:col-2">
                <span class="p-float-label">
                <InputText  format="number"  v-model="mob_number"  > </InputText>
                <label>Mobile Number</label>
              </span>
              </div>
             
              <div class="field col-2 md:col-2">
                <span class="p-float-label">
                    <Dropdown       id="User" 
                                    filter
                                    v-model="vehicle_dropdownItem" 
                                    :options="vehicle_dropdownItems" 
                                    optionLabel="name"
                                    style="width:150px"
                                    >
                      </Dropdown>
                      <label for="vehicle_type">Vehicle Type</label>
                </span>
              </div>              
            
              <div class="field col-2 md:col-2" v-if="user_key && (user_key=='Admin' || user_key=='admin')">
              <span class="p-float-label">
             
                <Dropdown v-if="user_key && (user_key=='Admin' || user_key=='admin')" style="width:150px" id="state" filter  v-model="client_id_search" :options="client_id_dropdown" optionLabel="name" :optionValue="code" @change="get_vehicle_type_master"></Dropdown>
                <label>Select Client</label>
              </span>
              </div>
              <div class="field col-1 md:col-2">
                <span class="p-float-label">
                  <Dropdown       
                    id="User" 
                    v-model="beacon_option" 
                    :options="beacon_dropdown" 
                    optionLabel="name"
                    style="width:150px"
                    >
                  </Dropdown>
                  <label for="vehicle_type">Beacon</label>
                </span>
              </div>
              <div class="field col-4 md:col-4">
                <Button
                  style="background-color: #349CE4; border: 1px solid #349CE4;"
                  icon="pi pi-search"
                  v-tooltip.bottom="'Search'"
                  @click="search(1)"
                />   
            </div>
          </div>
          </template>
<template v-slot:end>
          </template>
</Toolbar> -->

        <!-- data view live -->
        <DataView :value="products" :layout="layout" :rows=rows>
          <template #empty>
            <div class="text-center">
              <b style="text-align:center">No records found.</b>
            </div>
          </template>

          <template #header>
            <div class=" flex flex-column md:flex-row md:justify-content-between md:align-items-center ">
              <h5 class="m-0"><b> Vehicle Master</b></h5>
              <div>
                <Button icon="pi pi-refresh" @click="search(2)"
                  style="background-color: #349CE4; border: 1px solid #349CE4;" v-tooltip.bottom="'Refresh'" />
                <!-- <Button icon="pi pi-plus" class="ml-2" style="background-color: #349CE4; border: 1px solid #349CE4;"
                  v-tooltip.bottom="'Add'" @click="openNew" /> -->
                  <Button  class="ml-2" style="background-color: #349CE4; border: 1px solid #349CE4;"
                  v-tooltip.bottom="'Generate QR'" @click="GenerateQr" >Generate QR</Button>
              </div>
            </div>
            <div style="text-align:right;font-weight:bold;margin-top: 1%;"><span>Total Vehicles:</span>{{ totalRecords }}</div>
          </template>
          <template #grid="slotProps">
            <div class="grid grid-nogutter" v-if="slotProps.items">
              <div class="col-12 md:col-3 xs:col-3" v-for="(item, index) in slotProps.items">
                <div class="card m-3 border-1 surface-border zoom card-hover" style="background-color: #F8F9FA">
                  <p v-if="item.status == 'Active' || item.status == 'active'">
                    <badge :value=item.status severity="success"></badge>
                  </p>
                  <p v-else-if="item.status == 'InActive' || item.status == 'In Active'">
                    <badge :value=item.status severity="warning"></badge>
                  </p>
                  <p v-else-if="item.status == 'Delete' || item.status == 'Deleted'">
                    <badge :value=item.status severity="danger"></badge>
                  </p>

                  <div class="text-center">
                    <div class="image-wrapper">
                      <img v-if="item.photos && item.photos[0]" :src="item.photos[0]"
                        class="my-4 md:my-0 w-9 md:w-8rem shadow-2 shadow-2" :alt="Image" style="border-radius: 10px;height: 100%;" >
                      <img v-else
                        src="https://media.istockphoto.com/vectors/no-image-available-icon-vector-id1216251206?k=6&m=1216251206&s=612x612&w=0&h=G8kmMKxZlh7WyeYtlIHJDxP5XRGm9ZXyLprtVJKxd-o="
                        class="my-4 md:my-0 w-8 md:w-5rem shadow-2  shadow-2" />
                    </div>

                    <div class="grid nested-grid">
                      <div class="col-8">
                        <div class="grid">
                          <div class="col-12">
                            <div class="text-left  font-bold">
                              <div v-if="item.registration_number" class="font-bold text-md">
                                <p>{{ item.registration_number }}</p>
                              </div>
                              <div v-else class="font-bold text-md">
                                <p>--</p>
                              </div>
                              <div v-if="item.vehicle_type" class="font-bold text-lg">
                                <p>{{ item.vehicle_type }}</p>
                              </div>
                              <div v-else class="font-bold text-lg">
                                <p>--</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="text-center p-1 h-full">
                          <img :src="'images/scanner_sample.png'" class="clickable" @click="showQr(item)" :alt="Scanner"
                            style="cursor: pointer; width: 50px; height: 50px ">
                        </div>
                      </div>
                    </div>


                    <div class="grid">
                      <div class="col-4 text-left">
                        <p style="font-size: 12px; font-weight: 500; color: grey;margin-bottom: 5%;">Beacon </p>
                      </div>
                      <div class="col-8 text-left">
                        <p class=" clickable" @click="viewDevices(item)" v-tooltip.bottom="'Device List'"
                          style="color: blue; cursor: pointer; height: 7px; border: 1px solid white;">: {{
                          item.device_count }}</p>
                      </div>
                    </div>

                  </div>
                  <div class="flex align-items-center justify-content-between mt-3">
                    <Button icon="pi pi-eye" v-tooltip.bottom="'View'" class="p-button-rounded p-button-primary ml-2" @click="viewProduct(item)">
                    </Button>

                    <Button v-if="item.approval_flag && item.approval_flag==1" icon="pi pi-lock" v-tooltip.bottom="'Vehicle Lock'" class="p-button-rounded p-button-danger ml-2" @click="lock_Unlock(item,1)">
                    </Button>
                    <Button v-else icon="pi pi-lock-open" v-tooltip.bottom="'Vehicle Unlock'" class="p-button-rounded p-button-success ml-2" @click="lock_Unlock(item,2)">
                    </Button>

                    <Button icon="pi pi-pencil" v-tooltip.bottom="'Edit'" class="p-button-rounded p-button-warning p-component ml-2"
                      @click="editProduct(item)">
                    </Button>

                    <Button icon="pi pi-trash" v-tooltip.bottom="'Delete'" class="p-button-rounded p-button-danger ml-2"
                      @click="confirmDeleteProduct(item)">
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 md:col-4" v-else>
              <div class="card m-3 border-1 surface-border zoom card-hover">
                <p v-if="slotProps.data.status == 'Active' || slotProps.data.status == 'active'">
                  <badge :value=slotProps.data.status severity="success"></badge>
                </p>
                <p v-else-if="slotProps.data.status == 'InActive' || slotProps.data.status == 'In Active'">
                  <badge :value=slotProps.data.status severity="warning"></badge>
                </p>
                <p v-else-if="slotProps.data.status == 'Delete' || slotProps.data.status == 'Deleted'">
                  <badge :value=slotProps.data.status severity="danger"></badge>
                </p>

                <div class="text-center">
                  <div class="image-wrapper">
                    <img v-if="slotProps.data.photos && slotProps.data.photos[0]" :src="slotProps.data.photos[0]"
                      class="my-4 md:my-0 w-9 md:w-8rem shadow-2 shadow-2" :alt="Image" style="border-radius: 10px;">
                    <img v-else
                      src="https://media.istockphoto.com/vectors/no-image-available-icon-vector-id1216251206?k=6&m=1216251206&s=612x612&w=0&h=G8kmMKxZlh7WyeYtlIHJDxP5XRGm9ZXyLprtVJKxd-o="
                      class="my-4 md:my-0 w-8 md:w-5rem shadow-2  shadow-2" />
                  </div>

                  <div class="grid nested-grid">
                    <div class="col-8">
                      <div class="grid">
                        <div class="col-12">
                          <div class="text-left  font-bold">
                            <div v-if="slotProps.data.registration_number" class="font-bold text-md">
                              <p>{{ slotProps.data.registration_number }}</p>
                            </div>
                            <div v-else class="font-bold text-md">
                              <p>--</p>
                            </div>
                            <div v-if="slotProps.data.vehicle_type" class="font-bold text-lg">
                              <p>{{ slotProps.data.vehicle_type }}</p>
                            </div>
                            <div v-else class="font-bold text-lg">
                              <p>--</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-4">
                      <div class="text-center p-1 h-full">
                        <img :src="'images/scanner_sample.png'" class="clickable" @click="showQr(slotProps.data)"
                          :alt="Scanner" style="cursor: pointer; width: 50px; height: 50px ">
                      </div>
                    </div>
                  </div>

                  <div class="grid">
                    <div class="col-4 text-left">
                      <p style="font-size: 12px; font-weight: 500; color: grey;margin-bottom: 5%;">Beacon </p>
                    </div>
                    <div class="col-8 text-left">
                      <p class=" clickable" @click="viewDevices(slotProps.data)" v-tooltip.bottom="'Device List'"
                        style="color: blue; cursor: pointer; height: 7px; border: 1px solid white;">: {{
                          slotProps.data.device_count }}</p>
                    </div>
                  </div>

                </div>
                <div class="flex align-items-center justify-content-between mt-3">
                  <Button icon="pi pi-eye" class="p-button-rounded p-button-success"
                    @click="viewProduct(slotProps.data)">
                  </Button>

                  <Button icon="pi pi-pencil" class="p-button-rounded p-button-warning p-component ml-2"
                    @click="editProduct(slotProps.data)">
                  </Button>

                  <Button icon="pi pi-trash" v-tooltip.bottom="'Delete'" class="p-button-rounded p-button-danger ml-2"
                    @click="confirmDeleteProduct(slotProps.data)">
                  </Button>
                </div>
              </div>
            </div>
          </template>
        </DataView>

        <!-- data view local -->
        <!-- <DataView                 
                :value="products" 
                :layout="layout"   
                :rows=rows          
              >
                <template #empty>
                  <div class="text-center">
                    <b style="text-align:center">No records found.</b>
                  </div>
                </template>

                <template #header>
                    <div class=" flex flex-column md:flex-row md:justify-content-between md:align-items-center ">
                        <h5 class="m-0"><b> Vehicle Master</b></h5>
                        <div>
                            <Button icon="pi pi-refresh" @click="search(2)" style="background-color: #349CE4; border: 1px solid #349CE4;"   v-tooltip.bottom="'Refresh'"/>
                            <Button icon="pi pi-plus" class="ml-2" style="background-color: #349CE4;" v-tooltip.bottom="'Add'" @click="openNew" />
                        </div>
                    </div>
                    <div style="text-align:right;font-weight:bold"><span>Total Routes:</span>{{totalRecords}}</div>
                </template>                            

                <template #grid="slotProps">
                    <div class="col-12 md:col-3">                    
                      <div class="card m-3 border-1 surface-border zoom card-hover">
                        <p v-if="slotProps.data.status=='Active' ||slotProps.data.status=='active'"><badge :value=slotProps.data.status severity="success"></badge></p>
                        <p v-else-if="slotProps.data.status=='InActive' ||slotProps.data.status=='In Active'"><badge :value=slotProps.data.status severity="warning"></badge></p>
                        <p v-else-if="slotProps.data.status=='Delete' ||slotProps.data.status=='Deleted'"><badge :value=slotProps.data.status severity="danger"></badge></p>

                      <div class="text-center">
                        <div class="image-wrapper">
                          <img v-if="slotProps.data.photos && slotProps.data.photos[0]" :src="slotProps.data.photos[0]" class="my-4 md:my-0 w-9 md:w-8rem shadow-2 shadow-2" :alt="Image" style="border-radius: 10px;">
                          <img v-else src="https://media.istockphoto.com/vectors/no-image-available-icon-vector-id1216251206?k=6&m=1216251206&s=612x612&w=0&h=G8kmMKxZlh7WyeYtlIHJDxP5XRGm9ZXyLprtVJKxd-o=" class="my-4 md:my-0 w-8 md:w-5rem shadow-2  shadow-2"/>
                        </div>                       

                        <div class="grid nested-grid">
                          <div class="col-8">
                              <div class="grid">
                                  <div class="col-12">
                                      <div class="text-left  font-bold">
                                        <div v-if="slotProps.data.registration_number" class="font-bold text-md"><p>{{ slotProps.data.registration_number }}</p></div>
                                        <div v-else class="font-bold text-md"><p>--</p></div>
                                        <div v-if="slotProps.data.vehicle_type" class="font-bold text-lg"><p>{{ slotProps.data.vehicle_type }}</p></div>
                                        <div v-else class="font-bold text-lg"><p>--</p></div>
                                      </div>
                                  </div>                          
                              </div>
                          </div>
                          <div class="col-4">
                              <div class="text-center p-1 h-full">
                                <img 
                                  :src="'images/scanner_sample.png'" 
                                    class="clickable" 
                                    @click="showQr(slotProps.data)"
                                    :alt="Scanner" 
                                    style="cursor: pointer; width: 50px; height: 50px "
                                  >
                              </div>
                          </div>
                        </div> 
                        
                        <div class="grid">
                            <div class="col-4 text-left">
                              <p style="font-size: 12px; font-weight: 500; color: grey;margin-bottom: 5%;">Beacon </p>
                              </div>
                            <div class="col-8 text-left">
                                <p class=" clickable" 
                                    @click="viewDevices(slotProps.data)"
                                    v-tooltip.bottom="'Device List'"
                                    style="color: blue; cursor: pointer; height: 7px; border: 1px solid white;">: {{ slotProps.data.device_count }}</p>
                            </div>
                        </div>

                      </div>
                      <div class="flex align-items-center justify-content-between mt-3">
                        <Button 
                          icon="pi pi-eye"
                          class="p-button-rounded p-button-success"                           
                          @click="viewProduct(slotProps.data)"
                        >
                        </Button>                       

                        <Button 
                          icon="pi pi-pencil"
                          class="p-button-rounded p-button-warning p-component ml-2"                           
                          @click="editProduct(slotProps.data)"
                        >
                        </Button>

                        <Button
                            icon="pi pi-trash"
                            v-tooltip.bottom="'Delete'"
                            class="p-button-rounded p-button-danger ml-2"
                            @click="confirmDeleteProduct(slotProps.data)"
                          >
                        </Button> 
                      </div>
                    </div>
                    </div>
                </template>
        </DataView> -->

        <div class="pageno">
          <Paginator :rows="rows" :totalRecords="totalRecords" :rowsPerPageOptions="[8, 16, 24, totalRecords]"
            @page="onPageChange"></Paginator>
        </div>

        <!-- <DataView           
          :value="products" 
          :layout="layout" 
          :rows="rows"         
        >					
          <template #empty>
            <b style="text-align:center">No records found.</b>
          </template>

          <template #header>
              <div class=" flex flex-column md:flex-row md:justify-content-between md:align-items-center ">
                  <h5 class="m-0"><b> Vehicle Master</b></h5>
                  <div>
                      <Button icon="pi pi-refresh" @click="search(2)" style="background-color: #349CE4; border: 1px solid #349CE4;"   v-tooltip.bottom="'Refresh'"/>
                      <Button icon="pi pi-plus" class="ml-2" style="background-color: #349CE4; border: 1px solid #349CE4;" v-tooltip.bottom="'Add'" @click="openNew" />
                  </div>
              </div>
              <div style="text-align:right;font-weight:bold"><span>Total Routes:</span>{{totalRecords}}</div>
          </template>
					<template #list="slotProps">
						<div class="col-12">
							<div class="flex flex-column md:flex-row align-items-center p-3 w-full">

                <div class="md:w-10rem relative">
                  <img v-if="slotProps.data.photos && slotProps.data.photos[0]" :src="slotProps.data.photos[0]" class="my-4 md:my-0 w-9 md:w-10rem shadow-2 mr-5 shadow-2" :alt="Image" style="border-radius: 10px;">
                  <img v-else src="https://media.istockphoto.com/vectors/no-image-available-icon-vector-id1216251206?k=6&m=1216251206&s=612x612&w=0&h=G8kmMKxZlh7WyeYtlIHJDxP5XRGm9ZXyLprtVJKxd-o=" class="my-4 md:my-0 w-8 md:w-10rem shadow-2 mr-5 shadow-2" height="120"/>
                  <span class=" absolute" data-pc-name="tag" data-pc-section="root" style="left: 4px; top: 4px;">
                      <span v-if="slotProps.data.status=='Active' ||slotProps.data.status=='active'"><badge :value=slotProps.data.status severity="success"></badge></span>
                      <span v-else-if="slotProps.data.status=='InActive' ||slotProps.data.status=='In Active'"><badge :value=slotProps.data.status severity="warning"></badge></span>
                      <span v-else-if="slotProps.data.status=='Delete' ||slotProps.data.status=='Deleted'"><badge :value=slotProps.data.status severity="danger"></badge></span>
                  </span>
                </div>

                <div class="flex-1 md:text-left ml-3">	
                  
                  <img 
                    :src="'images/scanner_sample.png'" 
                    class="clickable" 
                    @click="showQr(slotProps.data)"
                    :alt="Scanner" 
                    style="border-radius: 10px; cursor: pointer; height: 100px; width: 100px;"
                  >							
								</div>

								<div class="flex-1 md:text-left" style="margin-left: -100px;">            
                  <div class="font-bold text-lg"><p>{{slotProps.data.vehicle_type}}</p></div>
									<div class="font-bold text-md"><p>{{slotProps.data.registration_number}}</p></div>									
								</div>

                <div class="flex-1 md:text-left" style="margin-left: -50px;">
									<div class="mb-1 font-bold text-md" >Driver   Name  : {{slotProps.data.driver_name}}</div>	
									<div class="mb-1 font-bold text-md" >Driver Mobile : {{slotProps.data.driver_mobile_number}}</div>	
                  <div class="mb-1 font-bold text-md">Beacon :
                    <span
                      style="color: blue; cursor: pointer;" 
                      class="clickable"
                      @click="viewDevices(slotProps.data)"
                      v-tooltip.bottom="'Device List'"
                      >{{ slotProps.data.device_count }}
                    </span>
                  </div>
									<div class="mb-1 font-bold text-md" v-if="slotProps.data.device_count>0">Mapped by : {{slotProps.data.mapped_by}}</div>		
									<div class="mb-1 font-bold text-md" v-if="slotProps.data.device_count>0">Mapped at : {{formatDate(slotProps.data.mapped_at)}}</div>									
																
								</div>

                <div class="flex-1 text-center md:text-right" style="margin-left: -10px;">                                  
                  
                  <div class="mb-1">
                    <button 
                      style="background-color: white; border: 1px solid #349CE4; color: #349CE4; width: 30%; padding: 5px;"                   
                      class="p-button flex-auto"
                      v-tooltip.bottom="'View'"
                      @click="viewProduct(slotProps.data)"
                    >
                      <span class="p-button-icon p-button-icon-left pi pi-eye"></span>
                      <span class="p-button-label" data-pc-section="label">View</span>
                    </button>	
                  </div>

                  <div class="mb-1">
                    <button 
                        style="background-color: white; border: 1px solid #349CE4; color: #349CE4; width: 30%; padding: 5px;"
                        class="p-button flex-auto" 
                        type="button"
                        @click="editProduct(slotProps.data)"
                      >
                        <span class="p-button-icon p-button-icon-left pi pi-pencil" style="margin-left: 5px;"></span>
                        <span class="p-button-label" data-pc-section="label" >Edit</span>
                    </button>
                  </div>  

                  <div class="mb-1">
                    <button 
                      style="background-color: #349CE4; width: 30%;border: 1px solid #349CE4; padding: 6px;"
                      class="p-button p-component flex-auto" 
                      type="button"
                      @click="confirmDeleteProduct(slotProps.data)"
                    >
                      <span class="p-button-icon p-button-icon-left pi pi-trash"></span>
                      <span class="p-button-label" data-pc-section="label">Delete</span>
                    </button>	
                  </div>

								</div>
							</div>
						</div>
					</template>			
				</DataView> -->


        <!-- <DataTable
          :loading="loading"
          ref="dt"
          :lazy="true"
          :totalRecords="totalRecords"
          :paginator="true"
          :value="products"
          v-model:selection="selectedProducts"
          :dataKey="columns[0]"
          :rows="limit"
          :filters="filters"
          @page="onPage($event)"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          :rowsPerPageOptions="[5, 10, 25, totalRecords]"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          responsiveLayout="scroll"
          style="font-size: 12px"
          :rowHover="true" showGridlines
        >
        <template #empty>
        <b style="text-align:center">No records found.</b>
      </template>
          <template #header>
            <div
              class="
                flex flex-column
                md:flex-row md:justify-content-between md:align-items-center
              "
            >
              <h5 class="m-0"><b> Manage Vehicle Master</b></h5>
              <div>
                <Button icon="pi pi-refresh" v-tooltip.bottom="'Refresh'" @click="search(2)" />&nbsp;
                <Button
                
                icon="pi pi-plus"
                v-tooltip.bottom="'Add'"
                @click="openNew"
              />
              </div>
              
            </div><div style="text-align:right;font-weight:bold"><span>Total Vehicles:</span>{{totalRecords}}</div>
          </template>

          <Column header="Sr No" style="min-width: 5rem;text-align: center;">
            <template #body="{ index}">
            <span v-if="page_no==1">{{ +index+ +1 }}</span>
              <span v-else>{{(+index+1)+limit*(page_no-1)}}</span>
            </template>
          </Column>

          <Column header="QR" headerStyle="min-width:5rem;">
            <template #body="slotProps">
             <Button
                icon="pi pi-bookmark"
                class="p-button-rounded p-button-primary mt-2"
                v-tooltip.bottom="'QR Code'"
                @click="showQr(slotProps.data)"
              />
             
            </template>
          </Column>
         
          <Column header="Status" style="min-width: 8rem ;text-align: center;" :field="columns[14]" >
            <template #body="{ data }">
              <span v-if="data.status=='Active' ||data.status=='active'"><badge :value=data.status severity="success"></badge></span>
            <span v-else-if="data.status=='InActive' ||data.status=='In Active'"><badge :value=data.status severity="warning"></badge></span>
            <span v-else-if="data.status=='Delete' ||data.status=='Deleted'"><badge :value=data.status severity="danger"></badge></span>
            <span v-else>-</span>
            </template>
          </Column>

          
          <Column header="Image" :field="columns[9]" style="text-align:center;">
            <template #body="{ data }">
              <img  :src="data.photos[0]" 
                    :alt="data.photos[0]" 
                    v-if="data.photos && data.photos[0]" 
                    class="shadow-2"
                    width="50">
              <img  v-else
                    src="https://media.istockphoto.com/vectors/no-image-available-icon-vector-id1216251206?k=6&m=1216251206&s=612x612&w=0&h=G8kmMKxZlh7WyeYtlIHJDxP5XRGm9ZXyLprtVJKxd-o="
                    class="shadow-2"
                    width="50"
            />
            </template>
          </Column>
          <Column header="Registration Number" :field="columns[9]" style="text-align:right;">
            <template #body="{ data }">
              {{ data.registration_number }}
            </template>
          </Column>
          <Column
            header="RC Mobile Number"
            style="min-width: 5rem"
            >
            <template #body="{ data }">
              {{ data.mobile_number_rc }}
            </template>
          </Column>
         
          
          <Column header="Beacon" :field="columns[10]" style="min-width: 10rem; text-align: center;">
            <template #body="slotProps">
              <span
                style="color: blue; cursor: pointer;" 
                class="clickable"
                @click="viewDevices(slotProps.data)"
                v-tooltip.bottom="'Device List'"
                >{{ slotProps.data.device_count }}
              </span>
            </template>
          </Column>

          <Column header="Mapped By" :field="columns[10]" style="min-width: 10rem; text-align: center;">
            <template #body="{data}">
              {{ data.mapped_by }}
            </template>
          </Column>

          <Column header="Mapped Date" :field="columns[10]" style="min-width: 10rem; text-align: center;">
            <template #body="{data}">
              {{ formatDate(data.mapped_at) }}
            </template>
          </Column>

          <Column header="Owner Name" :field="columns[10]" style="min-width: 10rem;">
            <template #body="{ data }">
              {{ data.owner_name }}
            </template>
          </Column>
          <Column header="Owner Mobile Number" :field="columns[10]">
            <template #body="{ data }">
              {{ data.owner_mobile_number }}
            </template>
          </Column>
          <Column header="Driver Name" :field="columns[10]">
            <template #body="{ data }">
              {{ data.driver_name }}
            </template>
          </Column>
          <Column header="Driver Mobile Number" :field="columns[10]">
            <template #body="{ data }">
              {{ data.driver_mobile_number }}
            </template>
          </Column>
          <Column header="vehicle Type" :field="columns[10]" style="min-width: 10rem;">
            <template #body="{ data }">
              {{ data.vehicle_type }}
            </template>
          </Column>

          <Column header="Action" headerStyle="min-width:15rem;">
            <template #body="slotProps">
              <Button
                  icon="pi pi-eye"
                  class="p-button-rounded p-button-success mr-2"
                  v-tooltip.bottom="'View'"
                  @click="viewProduct(slotProps.data)"
                />
              <Button
                icon="pi pi-pencil"
                v-tooltip.bottom="'Edit'"
                class="p-button-rounded p-button-primary mr-2"
                @click="editProduct(slotProps.data)"
              />
              
              <Button
                icon="pi pi-trash"
                v-tooltip.bottom="'Delete'"
                class="p-button-rounded p-button-warning mr-2"
                @click="confirmDeleteProduct(slotProps.data)"
              />
              
            </template>
          </Column>

          
        </DataTable> -->

        <Dialog v-model:visible="deviceDialog" :style="{ width: '1000px' }" header="Mapped Device List" :modal="true"
          class="p-fluid">
          <div class="card">
            <DataTable :value="device_data">

              <Column header="Status" style="min-width: 8rem ;text-align: center;" :field="columns[9]">
                <template #body="{ data }">
                  <span v-if="data.status == 'Active' || data.status == 'active'">
                    <badge :value=data.status severity="success"></badge>
                  </span>
                  <span v-else-if="data.status == 'InActive' || data.status == 'In Active'">
                    <badge :value=data.status severity="warning"></badge>
                  </span>
                  <span v-else-if="data.status == 'Delete' || data.status == 'Deleted'">
                    <badge :value=data.status severity="danger"></badge>
                  </span>
                  <span v-else>-</span>
                </template>
              </Column>

              <Column header="Action">
                <template #body="{ data }">
                  <button class="p-button p-1" type="button" style="font-size: 11px;" @click="editDevice(data)">
                    <span class="p-button-label">Change Status</span>
                  </button>
                </template>
              </Column>

              <Column header="Sr No" style="min-width: 5rem;text-align: center;">
                <template #body="{ index }">
                  <span v-if="page_no == 1">{{ +index + +1 }}</span>
                  <span v-else>{{ (+index + 1) + limit * (page_no - 1) }}</span>
                </template>
              </Column>

              <Column header="Beacon Identifier" :field="columns[6]" style="text-align:center;">
                <template #body="{ data }">
                  {{ data.beaconIndentifier }}
                </template>
              </Column>

              <Column header="Beacon MAC ID" :field="columns[2]" style="min-width: 10rem">
                <template #body="{ data }">
                  <span v-if="data.beaconMacId">{{ data.beaconMacId }}</span>
                  <span v-else>-</span>
                </template>
              </Column>

              <Column header="Beacon Accuracy" :field="columns[3]" style="min-width: 5rem">
                <template #body="{ data }">
                  <span v-if="data.beaconAccuracy">{{ data.beaconAccuracy }}</span>
                  <span v-else>-</span>
                </template>
              </Column>

              <Column header="Beacon Major" :field="columns[4]">
                <template #body="{ data }">
                  <span v-if="data.beaconMajor">{{ data.beaconMajor }}</span>
                  <span v-else>-</span>
                </template>
              </Column>

              <Column header="Beacon Minor">
                <template #body="{ data }">
                  <span v-if="data.beaconMinor">{{ data.beaconMinor }}</span>
                  <span v-else>-</span>
                </template>
              </Column>

              <Column header="Beacon RSSI" style="min-width: 5rem">
                <template #body="{ data }">
                  {{ data.beaconRssi }}
                </template>
              </Column>

              <Column header="Beacon Power" style="min-width: 5rem">
                <template #body="{ data }">
                  {{ data.beacontXPower }}
                </template>
              </Column>

            </DataTable>
          </div>
        </Dialog>

        <Dialog v-model:visible="updateProductDialog" :style="{ width: '450px' }" header="Confirm" :modal="true">
          <div class="flex align-items-center justify-content-center">
            <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
            <span v-if="product">Are you sure you want to update status ?</span>
          </div>
          <template #footer>
            <Button label="No" icon="pi pi-times" class="p-button-text" @click="updateProductDialog = false" />
            <Button label="Yes" icon="pi pi-check" class="p-button-text" @click="updatedevice" />
          </template>
        </Dialog>

        <Dialog v-model:visible="generateQRDialog" :style="{ width: '650px' }" header="Generate QR" :modal="true">
          <div class="p-fluid formgrid grid" style="margin-top: 10%">
            <div class="field col-12 md:col-6">
            <span class="p-float-label">
              <Dropdown v-if="user_key && (user_key == 'Admin' || user_key == 'admin')" id="state" filter
                v-model="client_id_search" :options="client_id_dropdown" optionLabel="name" :optionValue="code"
                ></Dropdown>
              <label>Select Client</label>
            </span>
          </div>
            
            <div class="field col-12 md:col-6">
            <span class="p-float-label">
              <InputText format="text" v-model="qrCount"> </InputText>
              <label>Total no of QR</label>
            </span>
          </div>
          
            </div>
          <template #footer>
            <Button label="Generate QR" class="p-button-text " style="background-color: 
#d6ebf9; border: 1px solid #246D9F;" @click="generate_QR" ></Button>
            <!-- <label>Generate QR</label> -->
            <!-- <Button  class="ml-2" style="background-color: #349CE4; border: 1px solid #349CE4;"
            v-tooltip.bottom="'Generate QR'" @click="generate_QR" >Generate QR</Button> -->
          </template>
        </Dialog>

        
        <Sidebar v-model:visible="productDialog" :baseZIndex="1000" position="full">
          <div class="col-12">
            <div class="card">
              <h5>User Form</h5>
              <hr />
              <div class="p-fluid formgrid grid">
                <div class="field col-12 md:col-2">
                  <label for="status">Status</label>
                  <Dropdown id="status" v-model="selectstatus" :options="dropdownItems" :value="dropdownItems.value"
                    optionLabel="name" placeholder="Select One" :class="{ 'p-invalid': submitted && !selectstatus }"
                    required="true"></Dropdown>
                </div>

                <div class="field col-12 md:col-2">
                  <label for="firsT_NAME">First Name</label>
                  <InputText id="firsT_NAME" type="text" v-model.trim="product.firsT_NAME" required="true" autofocus
                    :class="{ 'p-invalid': submitted && !product.firsT_NAME }" />
                </div>

                <div class="field col-12 md:col-2">
                  <label for="middeL_NAME">Middle Name</label>
                  <InputText id="middeL_NAME" type="text" v-model.trim="product.middeL_NAME" required="true" autofocus
                    :class="{ 'p-invalid': submitted && !product.middeL_NAME }" />
                </div>
                <div class="field col-12 md:col-2">
                  <label for="surname">Lastname</label>

                  <InputText id="surname" type="text" v-model.trim="product.surname" required="true" autofocus
                    :class="{ 'p-invalid': submitted && !product.surname }" />
                </div>
                <div class="field col-12 md:col-2">
                  <label for="aadhaR_CARD">Adhar No</label>
                  <InputText id="aadhaR_CARD" type="number" v-model.trim="product.aadhaR_CARD" required="true" autofocus
                    :class="{ 'p-invalid': submitted && !product.aadhaR_CARD }" />
                </div>
                <div class="field col-12 md:col-2">
                  <label for="state">State</label>
                  <InputText id="state" type="text" v-model.trim="product.state" required="true" autofocus
                    :class="{ 'p-invalid': submitted && !product.state }" />
                </div>

                <div class="field col-12 md:col-2">
                  <label for="disrtict">District</label>
                  <InputText id="disrtict" type="text" v-model.trim="product.disrtict" required="true" autofocus
                    :class="{ 'p-invalid': submitted && !product.disrtict }" />
                </div>
                <div class="field col-12 md:col-2">
                  <label for="taluka">Taluka</label>
                  <InputText id="taluka" type="text" v-model.trim="product.taluka" required="true" autofocus
                    :class="{ 'p-invalid': submitted && !product.taluka }" />
                </div>
                <div class="field col-12 md:col-2">
                  <label for="citY_VILLAGE">City/Village</label>
                  <InputText id="citY_VILLAGE" type="text" v-model.trim="product.citY_VILLAGE" required="true" autofocus
                    :class="{ 'p-invalid': submitted && !product.citY_VILLAGE }" />
                </div>
                <div class="field col-12 md:col-2">
                  <label for="pincode">Pincode</label>
                  <InputText id="pincode" type="number" v-model.trim="product.pincode" required="true" autofocus
                    :class="{ 'p-invalid': submitted && !product.pincode }" />
                </div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="card">
              <div class="p-fluid formgrid grid">
                <div class="field col-12">
                  <label for="address">Address</label>

                  <Textarea id="address" type="text" v-model.trim="product.address" required="true" autofocus
                    :class="{ 'p-invalid': submitted && !product.address }" />
                </div>
                <div class="field col-12 md:col-2">
                  <label for="mobile">Mobile No</label>
                  <InputText id="mobile" type="number" v-model.trim="product.mobile" required="true" autofocus :class="{
                    'p-invalid': submitted && !product.mobile,
                  }" />
                </div>
                <div class="field col-12 md:col-2">
                  <label for="email">Email</label>
                  <InputText id="email" type="text" v-model.trim="product.email" required="true" autofocus
                    :class="{ 'p-invalid': submitted && !product.email }" />
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 md:col-6">
            <Button v-if="product.admiN_ID" label="UPDATE" icon="pi pi-check" class="p-button-success mr-1 mb-1"
              @click="adduser" />
            <Button v-else label="ADD" icon="pi pi-check" class="p-button-success mr-1 mb-1" @click="adduser" />
            <Button label="Cancel" icon="pi pi-times" class="p-button-danger mr-1 mb-1" @click="visibleFull = false" />
          </div>
        </Sidebar>

        <Dialog v-model:visible="productDialog_old" :style="{ width: '450px', width: '450px' }" header="Year Details"
          :modal="true" class="p-fluid">
          <div class="grid">
            <div class="col-12 md:col-12">
              <div class="field">
                <!-- <img
            :src="'images/product/shoes.jpg'"
            :alt="product.image"
            width="150"
            class="mt-0 mx-auto mb-5 block shadow-2"
          /> -->
              </div>
              <div class="field">
                <label for="enrollmenT_YEAR">Enrollement Year <i style="color: green">(eg.2022)</i></label>
                <InputText id="enrollmenT_YEAR" v-model.trim="product.enrollmenT_YEAR" required="true" autofocus :class="{
                  'p-invalid': submitted && !product.enrollmenT_YEAR,
                }" />
              </div>
              <div class="field">
                <label for="exaM_YEAR">Exam Year <i style="color: green">(eg.2022-23)</i></label>
                <InputText id="exaM_YEAR" v-model.trim="product.exaM_YEAR" required="true" autofocus
                  :class="{ 'p-invalid': submitted && !product.exaM_YEAR }" />
                <!-- <small class="p-invalid" v-if="submitted && !product.name"
                  >Name is required.</small
                > -->
              </div>
              <!-- <div class="field">
                <label for="description">Description</label>
                <Textarea
                  id="description"
                  v-model.trim="product.description"
                  required="true"
                  autofocus
                  :class="{ 'p-invalid': submitted && !product.description }"
                />
              </div>
              <div class="field">
                <label for="link">Video Link</label>
                <InputText
                  id="link"
                  v-model.trim="product.videolink"
                  required="true"
                  autofocus
                  :class="{ 'p-invalid': submitted && !product.link }"
                />
              </div>
              
              <div class="field">
                <label for="status">Type</label>

                <Dropdown
                  id="state"
                  v-model="selectstatus"
                  :options="dropdownItems"
                  :value="dropdownItems.value"
                  optionLabel="name"
                  placeholder="Select One"
                  :class="{ 'p-invalid': submitted && !selectstatus }"
                  required="true"
                ></Dropdown>
              </div>

              <div class="field">
                <label for="status">Status</label>

                <Dropdown
                  id="state"
                  v-model="selectstatus2"
                  :options="dropdownItems2"
                  :value="dropdownItems2.value"
                  optionLabel="name"
                  placeholder="Select One"
                  :class="{ 'p-invalid': submitted && !selectstatus2 }"
                  required="true"
                ></Dropdown>
              </div> -->
            </div>
            <div class="col-12 md:col-6">
              <!-- <Button
                v-if="product.mjyeaR_ID"
                label="UPDATE"
                icon="pi pi-check"
                class="p-button-success mr-1 mb-1"
                @click="Addyear"
               
              />
              <Button
                v-else
                label="ADD"
                icon="pi pi-check"
                class="p-button-success mr-1 mb-1"
                @click="Addyear"
              /> -->
            </div>
            <div class="col-12 md:col-6">
              <Button label="Cancel" icon="pi pi-times" class="p-button-danger mr-1 mb-1"
                @click="productDialog = false" />
            </div>
          </div>
        </Dialog>
        <Dialog v-model:visible="qrCodetDialog" :style="{ width: '450px' }" header="QR Code" :modal="true">
          <div style="text-align:right">
            <Button icon="pi pi-print" @click="printQr()" class="p-button-rounded p-button-info mr-2 mb-2" />
            <!-- <Button  icon="pi pi-download" @click="downloadQr()" class="p-button-rounded p-button-info mr-2 mb-2" /> -->
          </div>
          <br>
          <div>
            <qrcode-vue id="qrprint" type="image/png" style="width:100%" :value="qrcodevalue" size="450" level="H" />
          </div>
        </Dialog>
        <Dialog v-model:visible="deleteProductDialog" :style="{ width: '450px' }" header="Confirm" :modal="true">
          <div class="flex align-items-center justify-content-center">
            <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
            <span v-if="product">Are you sure you want to delete  <b>{{ product.firsT_NAME }}</b>?</span>
          </div>
          <template #footer>
            <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteProductDialog = false" />
            <Button label="Yes" icon="pi pi-check" class="p-button-text" @click="deleteuser" />
          </template>
        </Dialog>
       

        <Dialog v-model:visible="deleteProductsDialog" :style="{ width: '450px' }" header="Confirm" :modal="true">
          <div class="flex align-items-center justify-content-center">
            <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
            <span v-if="product">Are you sure you want to delete the selected products?</span>
          </div>
          <template #footer>
            <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteProductsDialog = false" />
            <Button label="Yes" icon="pi pi-check" class="p-button-text" @click="deleteSelectedProducts" />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { FilterMatchMode } from "primevue/api";
import ProductService from "../service/ProductService";
import JsonExcel from "vue-json-excel";
import QrcodeVue from 'qrcode.vue'
import BreadcrumbService from "../service/BreadcrumbService";


//import FormNewsMaster from "@/components/FormNewsMaster";
//import * as Survey from "survey-vue";

// import axios from "axios";
import apis from "@/apis";
import axios from "axios";

export default {
  data() {
    return {
      qrCount:"",
      showFilter: false,
      layout: "grid",
      rows: 8,
      currentPage: 1,
      rowsPerPage: 8,
      perPageOptions: [8, 16, 24, 1000],
      beacon_dropdown: [
        { name: "Mapped", value: "yes" },
        { name: "Not Mapped", value: "no" },
        { name: "Both", value: "" },
      ],
      beacon_option: "",
      device_data: {},
      update_device_data: {},
      temp_data: {},
      vehicle_status: '',
      vehicle_status_dropdown: [{ name: "Deleted", value: "Deleted" },
      { name: "Active", value: "Active" },
      { name: "InActive", value: "InActive" }],
      client_id_dropdown: [],
      client_id_search: '',
      reg_number: '',
      mob_number: '',
      filter_createIdDate:'',
      filter_createIdDateTO:'',
      owner_driver_name: '',
      vehicle_dropdownItems: [],
      vehicle_dropdownItem: '',
      deleteProductDialog: false,
      product: null,
      isDeleted: false,
      isLoadingModel: false,

      page_no: 1,
      qrcodevalue: "123444",
      isLoading: false,
      isLoadingModel: false,
      loading: false,
      fullPage: true,
      qrCodetDialog: false,
      file_attachment: "",
      // dropdownItems: [
      //   { name: "Motivational", value: "Motivational" },
      //   { name: "Interview", value: "Interview" },
      // ],
      dropdownItems: [
        { name: "Active", value: "Active" },
        { name: "InActive", value: "InActive" },
        { name: "Deleted", value: "Deleted" },
      ],
      products: null,
      user_key: "",
      productDialog: false,
      generateQRDialog:false,
      qrCount:'',
      deviceDialog: false,
      updateProductDialog: false,
      deleteProductDialog: false,
      deleteProductsDialog: false,
      lazyParams: {},
      product: {},
      selectedProducts: null,
      filters: {},
      offset: 1,
      selectstatus: { name: "", value: "" },
      // selectstatus2: { name: "Motivational", value: "Motivational" },
      limit: 8,
      columns: [],
      head: [
        "Data Usages",
        "Network Connectivity",
        "Students",
        "Teachers",
        "Student Registration",
        "News Master",
        "Government Panel",
        "Feedback Master",
        "User Queries",
        "Schemes Master",
        "Notice Master",
        "Subject Master",
        "Teacher Schedule Master",
        "Teacher Schedule DE Master",
        "Query Types Master",
        "Sub Query Types Master",
        "Admin Users",
        "Application Roles",
        "Departments",
        "Cast Master",
        "Year Master",
        "District Master",
        "Student Attendance",
        "Student Document",
        "Teachers",
        "Radical ids",
        "Subject Topics",
        "Query Comments",
        "Student Submit Answers",
        "Mock Tests",
        "Mock Test Papers",
        "Mock Test Results",
        "Video",
        "Syllabus",
        "Course",
      ],
      pageno: 1,
      submitted: false,
      totalRecords: 0,
      id: "",
      statuses: [
        { label: "INSTOCK", value: "instock" },
        { label: "LOWSTOCK", value: "lowstock" },
        { label: "OUTOFSTOCK", value: "outofstock" },
      ],
      BreadcrumbService: null,
      breadcrumbHome: {},
      breadcrumbItems: [],
    };
  },
  productService: null,
  async created() {
    this.productService = new ProductService();
    this.user_key = localStorage.getItem("user_key");
    this.initFilters();
    this.get_client_list();
    this.get_vehicle_type_master();
    this.showFilter = false;
    this.BreadcrumbService = new BreadcrumbService();
    let Breadcrum_data = this.BreadcrumbService.vehiclemaster()
    this.breadcrumbHome = Breadcrum_data.home;
    this.breadcrumbItems = Breadcrum_data.items;
  },
  async mounted() {
    // this.productService.getProducts().then(data => this.products = data);
    this.id = this.$route.params.id;

    this.lazyParams = {
      first: 0,
      rows: this.limit,
      sortField: null,
      sortOrder: null,
      filters: this.filters,
    };
    if (this.totalRecords == 0) {
      await this.get_count();
    }
    await this.get_list();
    //alert(this.id);
  },
  watch: {
    async $route() {
      this.products = [];
      this.columns = [];
      this.totalRecords = 0;
      this.id = this.$route.params.id;
      if (this.id) {
        await this.get_count();
        this.get_list();
      }
    },
  },
  methods: {
    lock_Unlock(data,flag)
    {
        var id = data._id;
        var type="";
        if(flag==1) 
        {
          type='UnLock';
        }
        else if(flag==2)
        {
          type='Lock';
        }

        var data = {
          "id":id,
          "type":type
        }
        this.isLoadingModel = true;
        var promises = apis.lockunlockVehicle(data);
        promises
          .then((response) => {
            this.isLoadingModel = false;
            this.$swal.fire(response.data.data.message);
            this.get_list();
            this.get_count();
          });
    },
    generate_QR()
    {
        if (this.qrCount==0 || this.qrCount=='') 
        {
          this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please enter total no of QR",
          life: 3000,
        });
        return false;
        }
        var client_id = this.client_id_search.code ? this.client_id_search.code : localStorage.getItem("client_id");

        var data = {
          "qrcount":this.qrCount,
          "user_id":localStorage.getItem("id"),
          "client_id":client_id
        }
        this.isLoadingModel = true;
        var promises = apis.generateqr(data);
        promises
          .then((response) => {
            this.isLoadingModel = false;
            if (response.data.data.status==true) {
              this.generateQRDialog = false;
              this.$swal(response.data.data.message);
              this.get_list();
              this.get_count();
            } else {
              
              this.$swal(response.data.data.message);
              
            }
            
          })
          .catch((error) => {
            //console.log(error);
            this.isLoadingModel = false;
            this.generateQRDialog = false;

            this.$swal.fire(response.data.data.message);
            this.get_list();
            this.get_count();
          });



    },
    FormatTitle(data, count = 2) {
      if (data) {
        let word = data.substring(0, count);
        return word;
      }
    },
    show_filter() {
      this.showFilter = true;
    },
    async onPageChange(event) {
      this.currentPage = event.page + 1;
      this.page_no = event.page + 1;
      this.limit = this.rows;
      this.rows = event.rows;
      
      await this.get_list();
      await this.get_count();
    },
    formatDate(dateString) {
      if (!dateString || isNaN(Date.parse(dateString))) {
        return '';
      }
      var date = new Date(dateString);
      var day = date.getDate().toString().padStart(2, '0');
      var month = (date.getMonth() + 1).toString().padStart(2, '0'); // Month is zero-based
      var year = date.getFullYear();
      return day + "-" + month + "-" + year;
    },
    get_vehicle_type_master() {
      var client_id = this.client_id_search.code ? this.client_id_search.code : localStorage.getItem("client_id");
      this.loading = true;
      var data = {
        client_id: client_id

      };
      var promise = apis.vehicle_type_master(data);
      promise.then((response) => {
        this.loading = false;

        if (response.data.data) {
          var temp_data = [];
          for (let x = 0; x < response.data.data.length; x++) {
            temp_data.push({
              name: response.data.data[x].name, value: response.data.data[x].name
            });

          }
          this.vehicle_dropdownItem = '';
          this.vehicle_dropdownItems = temp_data;
        }

      });
    },
    isNumber(evt) {
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 32 && (charCode > 65 || charCode < 90)) {
        evt.preventDefault();
      }
    },
    async search(count) {
      // count==2?this.client_id_search='':'';
      // count==2?this.reg_number='':'';
      // count==2?this.mob_number='':'';
      // count==2?this.vehicle_dropdownItem = '':'';
      if (count == 2) {
        this.client_id_search = '';
        this.reg_number = '';
        this.mob_number = '';
        this.filter_createIdDate='';
        this.filter_createIdDateTO='';
        this.owner_driver_name = '';
        this.vehicle_dropdownItem = '';
        this.beacon_option = "",
          this.showFilter = false;
        this.get_vehicle_type_master();
      }
      await this.get_list();
      await this.get_count();
    },
    get_client_list() {
      var data = { count: false, };
      var promise = apis.getclientist(data);
      promise.then((response) => {
        if (response.data.data) {
          response.data.data
            .filter(item => item.client_name)
            .map(item => this.client_id_dropdown.push({ name: item.client_name, code: item._id }));
        }
      });
    },
    editDevice(device) {
      this.update_device_data = device;
      this.updateProductDialog = true;
    },
    updatedevice() {
      var status = "";
      if (this.update_device_data.status == "Active") {
        status = "InActive";
      }
      else {
        status = "Active";
      }
      if (this.update_device_data._id) {
        var data = {
          "_id": this.update_device_data._id,
          "vehicle_id": this.update_device_data.vehicle_id,
          "user_id": this.update_device_data.created_by,
          "status": status,
          "created_at": this.update_device_data.created_at,
          "beaconIndentifier": this.update_device_data.beaconIndentifier,
          "beaconMacId": this.update_device_data.beaconMacId,
          "beaconUUID": this.update_device_data.beaconUUID,
          "beaconAccuracy": this.update_device_data.beaconAccuracy,
          "beaconMajor": this.update_device_data.beaconMajor,
          "beaconMinor": this.update_device_data.beaconMinor,
          "beaconProximity": this.update_device_data.beaconProximity,
          "beaconRssi": this.update_device_data.beaconRssi,
          "beacontXPower": this.update_device_data.beacontXPower
        };
        console.log("update data", data);
        this.isLoadingModel = true;
        var promise = apis.EditVehicleDeviceMapp(data);
        promise
          .then((responseapi) => {
            this.isLoadingModel = false;
            this.updateProductDialog = false;
            this.$toast.add({
              severity: "success",
              summary: "Status",
              detail: "Updated Successfully",
              life: 3000,
            });
            this.get_device_data();
          })
          .catch((error) => {
            this.isLoadingModel = false;
            this.updateProductDialog = false;
            this.$toast.add({
              severity: "error",
              summary: "error",
              detail: "Not Updated ",
              life: 3000,
            });
            this.get_device_data();
          });
      }
      this.updateProductDialog = false;
    },
    async viewDevices(product) {
      this.temp_data = product;
      this.get_device_data();
      this.deviceDialog = true;
    },
    get_device_data() {
      var vehicle = this.temp_data.vehicle_id;
      var data = {
        limit: 1000,
        page_no: 1,
        count: false,
        vehicle_id: vehicle
      };
      console.log(data);
      this.loading = true;
      var promise = apis.VehicleDeviceMappingList(data, this.id);
      promise.then((response) => {
        this.loading = false;
        console.log(response);
        this.device_data = response.data.data;
      });
    },
    async viewProduct(product) {

      // var data=[product]
      console.log(JSON.stringify(product));
      await localStorage.setItem('saveprofilevehicledata', JSON.stringify(product));
      this.$router.push({ name: "vehicleprofile" });
    },
    async downloadQr() {
      var canvas = await document.getElementById("qrprint");
      var anchor = document.createElement("a");
      anchor.href = canvas.toDataURL("image/png");
      anchor.download = "QrIMAGE.PNG";
      anchor.click();
    },
    async printQr() {
      var dataUrl = await document.getElementById('qrprint').toDataURL(); //attempt to save base64 string to server using this var  
      var windowContent = await '<!DOCTYPE html>';
      windowContent += await '<html>'
      windowContent += await '<head><title>Print canvas</title></head>';
      windowContent += await '<body>'
      windowContent += await '<img src="' + dataUrl + '">';
      windowContent += await '</body>';
      windowContent += await '</html>';
      var printWin = window.open('', '', 'width=900,height=600,align=center');
      // alert(windowContent);
      await printWin.document.open();
      await printWin.document.write(await windowContent);
      printWin.document.close();
      printWin.focus();
      printWin.print();
      // printWin.close();
    },
    //a simple date formatting function
    dateFormat(inputDate) {
      var postdate = inputDate;
      if (inputDate) {
        inputDate = new Date(inputDate);
        if (inputDate.toString() == 'NaN-NaN-NaN') {
          return postdate;

        }
        else {
          let date = ("0" + inputDate.getDate()).slice(-2);

          // current month
          let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);

          // current year
          let year = inputDate.getFullYear();
          if (date.toString() == 'aN') {
            return postdate;
          }
          else {
            return date + "-" + month + "-" + year;
          }
        }
      }
      else {
        return "";
      }
    },
    handleFileUpload() {
      this.file_attachment = this.$refs.file_attachment.files[0];

      //alert(this.$refs.file_attachment.files[0].name);
    },
    async onPage(event) {
      this.lazyParams = event;
      this.page_no = event.page + 1;
      this.limit = event.rows;
      // console.log(event);
      //  await this.get_count();
      if (this.totalRecords > 0) {
        this.get_list();
      }
    },
    dateFormatYMD(inputDate) {
        var postdate=inputDate;
        if(inputDate)
        {
            inputDate=new Date(inputDate);
            if(inputDate.toString()=='NaN-NaN-NaN')
            {
                return postdate;
                
            }
            else
            {
                let date = ("0" + inputDate.getDate()).slice(-2);

        // current month
                let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);

                // current year
                let year = inputDate.getFullYear();
                if(date.toString()=='aN')
                {
                  return postdate;
                }
                else
                {
                  return year+"-"+month+"-"+date;
                }
            }
        }
        else {
           return "";
        }
    },
    get_count: function () {
      var client_id = this.client_id_search.code ? this.client_id_search.code : localStorage.getItem("client_id");
      var beacon = "";
      if (this.beacon_option != "") {
        beacon = this.beacon_option.value;
      }
      var data = {
        // id: localStorage.getItem("id"),
        count: true,
        client_id: client_id,
        registration_number: this.reg_number,
        mobile_number: this.mob_number,
        from_date:this.dateFormatYMD(this.filter_createIdDate),
        to_date:this.dateFormatYMD(this.filter_createIdDateTO),
        vehicle_type: this.vehicle_dropdownItem.value,
        owner_driver_name: this.owner_driver_name,
        beacon: beacon

      };
      this.isLoadingModel = true;
      var promise = apis.vehiclelist(data, this.id);
      promise.then((response) => {
        this.isLoadingModel = false;
        console.log(response);
        this.totalRecords = response.data.data;
        //alert(this.totalRecords);
      });

      console.log(data);
    },
    get_list: function () {
      this.products = [];
      var client_id = this.client_id_search.code ? this.client_id_search.code : localStorage.getItem("client_id");
      var beacon = "";
      if (this.beacon_option != "") {
        beacon = this.beacon_option.value;
      }

      var data = {
        // id: localStorage.getItem("id"),
        client_id: client_id,
        limit: this.limit,
        page_no: this.page_no,
        count: false,
        registration_number: this.reg_number,
        mobile_number: this.mob_number,
        from_date:this.dateFormatYMD(this.filter_createIdDate),
        to_date:this.dateFormatYMD(this.filter_createIdDateTO),
        vehicle_type: this.vehicle_dropdownItem.value,
        owner_driver_name: this.owner_driver_name,
        beacon: beacon
        //client_id: localStorage.getItem("client_id")?localStorage.getItem("client_id"):''
      };
      this.isLoadingModel = true;
      var promise = apis.vehiclelist(data, this.id);
      promise.then((response) => {
        this.isLoadingModel = false;
        console.log(response);
        this.products = response.data.data;
        console.log(this.products[0]);
        if (this.columns.length == 0) {
          if (this.products.length > 0) {
            this.columns = Object.keys(this.products[0]);
          }
        }
      });

      console.log(data);
    },
    formatCurrency(value) {
      if (value)
        return value.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
        });
      return;
    },
    openNew() {
      this.product = {};
      this.submitted = false;
      // this.productDialog = true;
      this.$router.push({ name: "vehicle_add" });
    },
    GenerateQr()
    {
      this.product = {};
      this.submitted = false;
      this.qrCount='';
      this.client_id_search="";
      this.generateQRDialog = true;
    },
    hideDialog() {
      this.productDialog = false;
      this.submitted = false;
    },
    async adduser() {
      this.submitted = true;
      if (!this.selectstatus.value) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Select Status",
          life: 3000,
        });
        return false;
      }
      if (!this.product.firsT_NAME) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter First Name",
          life: 3000,
        });
        return false;
      }
      if (!this.product.middeL_NAME) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter Middle Name",
          life: 3000,
        });
        return false;
      }
      if (!this.product.surname) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter LastName",
          life: 3000,
        });
        return false;
      }
      if (!this.product.aadhaR_CARD) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter Adhar No",
          life: 3000,
        });
        return false;
      }

      if (!this.product.state) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter State",
          life: 3000,
        });
        return false;
      }
      if (!this.product.disrtict) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter District",
          life: 3000,
        });
        return false;
      }
      if (!this.product.taluka) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter Taluka",
          life: 3000,
        });
        return false;
      }
      if (!this.product.citY_VILLAGE) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter city/village",
          life: 3000,
        });
        return false;
      }
      if (!this.product.pincode) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter Pincode",
          life: 3000,
        });
        return false;
      }
      if (!this.product.address) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter address",
          life: 3000,
        });
        return false;
      }
      if (!this.product.mobile) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter mobile",
          life: 3000,
        });
        return false;
      }
      if (!this.product.email) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter email",
          life: 3000,
        });
        return false;
      }

      //edit
      if (this.product.admiN_ID) {
        var data = {
          Admin_id: this.product.admiN_ID,
          firsT_NAME: this.product.firsT_NAME,
          middeL_NAME: this.product.middeL_NAME,
          surname: this.product.surname,
          address: this.product.address,
          state: this.product.state,
          disrtict: this.product.disrtict,
          taluka: this.product.taluka,
          citY_VILLAGE: this.product.citY_VILLAGE,
          mobile: parseInt(this.product.mobile),
          email: this.product.email,
          pincode: parseInt(this.product.pincode),
          aadhaR_CARD: parseInt(this.product.aadhaR_CARD),
          status: this.selectstatus.value,
          createD_BY: localStorage.getItem("full_name"),
        };
        this.isLoadingModel = true;
        var promise = apis.editusermaster(data);
        promise
          .then((responseapi) => {
            this.$swal(responseapi.data.message);
            this.isLoadingModel = false;
            this.productDialog = false;
            this.get_list();
            this.get_count();
          })
          .catch((error) => {
            //console.log(error);
            this.isLoadingModel = false;
            this.productDialog = false;

            this.$swal.fire(error.response.data);
            this.get_list();
            this.get_count();
          });
      }
      //add-----------------------------------------------------------------------------------------------------------------
      else {
        var data1 = {
          firsT_NAME: this.product.firsT_NAME,
          middeL_NAME: this.product.middeL_NAME,
          surname: this.product.surname,
          address: this.product.address,
          state: this.product.state,
          disrtict: this.product.disrtict,
          taluka: this.product.taluka,
          citY_VILLAGE: this.product.citY_VILLAGE,
          mobile: parseInt(this.product.mobile),
          email: this.product.email,
          pincode: parseInt(this.product.pincode),
          aadhaR_CARD: parseInt(this.product.aadhaR_CARD),
          status: this.selectstatus.value,
          createD_BY: localStorage.getItem("full_name"),
        };
        this.isLoadingModel = true;
        var promises = apis.addusermaster(data1);
        promises
          .then((response) => {
            this.isLoadingModel = false;
            this.productDialog = false;
            this.$swal(response.data.message);
            this.get_list();
            this.get_count();
          })
          .catch((error) => {
            //console.log(error);
            this.isLoadingModel = false;
            this.productDialog = false;

            this.$swal.fire(error.response.data);
            this.get_list();
            this.get_count();
          });
      }

      this.selectstatus = { name: "", value: "" };
      //  this.selectstatus2={name:"",value:""}
    },
    saveProduct() {
      this.submitted = true;
      if (this.product.name.trim()) {
        if (this.product.id) {
          this.product.inventoryStatus = this.product.inventoryStatus.value
            ? this.product.inventoryStatus.value
            : this.product.inventoryStatus;
          this.products[this.findIndexById(this.product.id)] = this.product;
          this.$toast.add({
            severity: "success",
            summary: "Successful",
            detail: "Product Updated",
            life: 3000,
          });
        } else {
          this.product.id = this.createId();
          this.product.code = this.createId();
          this.product.image = "product-placeholder.svg";
          this.product.inventoryStatus = this.product.inventoryStatus
            ? this.product.inventoryStatus.value
            : "INSTOCK";
          this.products.push(this.product);
          this.$toast.add({
            severity: "success",
            summary: "Successful",
            detail: "Product Created",
            life: 3000,
          });
        }
        this.productDialog = false;
        this.product = {};
      }
    },
    async editProduct(product) {
      this.file_attachment = "";
      this.product = { ...product };
      //this.productDialog = true;
      this.selectstatus.value = this.product.status;
      this.selectstatus.name = this.product.status;

      await localStorage.setItem('savevehicledata', '');
      await localStorage.setItem('savevehicledata', JSON.stringify(product));
      this.$router.push({ name: "vehicle_edit" });
    },
    confirmDeleteProduct(product) {
      this.product = product;
      
      this.deleteProductDialog = true;
    },
    showQr(product) {
      //this.qrcodevalue='vehicle_id-'+product._id;
      this.qrcodevalue = product.uicode;
      this.qrCodetDialog = true;
      // this.product = product;
      // this.deleteProductDialog = true;
    },
    deleteProduct() {
      this.products = this.products.filter((val) => val.id !== this.product.id);
      this.deleteProductDialog = false;
      this.product = {};
      this.$toast.add({
        severity: "success",
        summary: "Successful",
        detail: "Product Deleted",
        life: 3000,
      });
    },
   async deleteuser() {
    // this.deleteProductDialog = false;
      if (this.product.status ==  'Delete' || this.product.status == 'Deleted')  {
        this.deleteProductDialog = false;
        
        this.$swal("This record has already been deleted.");
        return;
        
      }
      if (this.product && this.product._id) {
        var data = {
          id: this.product._id,
          user_id: localStorage.getItem("id")
        };
        this.isLoadingModel = true;
        var promise = apis.deletevehicle(data);
        promise.then((responseapi) => {
          this.isLoadingModel = false;
          if (responseapi.data.status == true) {
            this.isDeleted = true; 
            this.deleteProductDialog = false;
            this.$swal(responseapi.data.message);
            this.get_list();
            this.get_count();
          } else {
            this.$swal("Error deleting vehicle.");
          }
        }).catch(() => {
          this.isLoadingModel = false;
          this.$swal("Error deleting vehicle.");
        });
      }
    },

    // deleteuser() {
    //   if (this.product._id) {
    //     var data = {
    //       id: this.product._id,
    //       user_id: localStorage.getItem("id")
    //     };
    //     this.isLoadingModel = true;
    //     var promise = apis.deletevehicle(data);
    //     promise.then((responseapi) => {
    //       this.isLoadingModel = false;
    //       if (responseapi.data.status == true) {
    //         // this.hideDialog1();
    //         this.deleteProductDialog = false;
    //         this.$swal(responseapi.data.message);
    //         this.get_list();
    //         this.get_count();
    //       } else {
    //         this.$swal("error to Delete vehicle");
    //       }
    //     });
    //   }
    // },
    findIndexById(id) {
      let index = -1;
      for (let i = 0; i < this.products.length; i++) {
        if (this.products[i].id === id) {
          index = i;
          break;
        }
      }
      return index;
    },
    formatDate(dateString) {
      if (!dateString || isNaN(Date.parse(dateString))) {
        return '';
      }
      var date = new Date(dateString);
      var day = date.getDate().toString().padStart(2, '0');
      var month = (date.getMonth() + 1).toString().padStart(2, '0'); // Month is zero-based
      var year = date.getFullYear();
      return day + "-" + month + "-" + year;
    },
    createId() {
      let id = "";
      var chars =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (var i = 0; i < 5; i++) {
        id += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return id;
    },

    async exportCSV() {
      this.limit = this.totalRecords;
      this.get_list();
      await this.$refs.dt.exportCSV();
    },
    confirmDeleteSelected() {
  
      this.deleteProductsDialog = true;

      
    },
    deleteSelectedProducts() {
      this.products = this.products.filter(
        (val) => !this.selectedProducts.includes(val)
      );
      this.deleteProductsDialog = false;
      this.selectedProducts = null;
      this.$toast.add({
        severity: "success",
        summary: "Successful",
        detail: "Products Deleted",
        life: 3000,
      });
    },
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
  },
  components: { downloadExcel: JsonExcel, QrcodeVue },
};
</script>

<style scoped lang="scss">
@import "../assets/demo/badges.scss";

.image-wrapper {
  height: 100px;
}

.card-hover:hover {
  transform: scale(1.04);
  transition: transform 0.5s;
}


</style>
